import './ToggleThemeBtn.styles.scss';

import React, { useContext } from 'react';
import Menu from '@material-ui/core/Menu';
import { IconButton } from '@material-ui/core';
import { Brightness6Outlined, CheckRounded } from '@material-ui/icons';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import { themesArray } from '../../theme';
import { useEffect } from 'react';

const ToggleThemeBtn = () => {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const [appliedThemeId, setAppliedThemeId] = React.useState(null);
	const { setMyThemeType, setMyThemeName, themeType, themeName } = useContext(
		MyThemeContext
	);

	useEffect(() => {
		const foundTheme = themesArray.find(theme => theme.name === themeName);
		if (foundTheme) setAppliedThemeId(foundTheme.id);
	}, [themeName]);

	const handleClick = event => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const chooseTheme = (themeType, themeName, id, e) => {
		setMyThemeType(themeType);
		setMyThemeName(themeName);
		handleClose();
		e.stopPropagation();
	};

	return (
		<div className="themeBtnsWrapper">
			{/* <Tooltip title="Toggle light/dark theme" onClick={handleClick}>
				<IconButton>
					<Brightness6Outlined />
				</IconButton>
			</Tooltip> */}
			<IconButton onClick={handleClick}>
				<Brightness6Outlined />
			</IconButton>
			<Menu
				className="themeMenu"
				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}
			>
				{themesArray.map(({ id, type, name }) => (
					<div
						key={id}
						className={`themeCircleBtn ${name} ${themeType}ThemeSelected ${
							appliedThemeId === id ? 'applied' : ''
						}`}
						onClick={e => chooseTheme(type, name, id, e)}
					>
						{appliedThemeId === id && <CheckRounded className="appliedIcon" />}
					</div>
				))}
			</Menu>
		</div>
	);
};

export default ToggleThemeBtn;
